import { queryOptions } from '@tanstack/react-query';
import { getAgencies, getAgencyById } from '@/actions/agencies';

const RESOURCE = 'agencies' as const;

const agencies = {
  byId: (id: number) =>
    queryOptions({
      queryFn: () => getAgencyById(id),
      queryKey: [RESOURCE, id] as const,
    }),
  all: () =>
    queryOptions({
      queryFn: () => getAgencies(),
      queryKey: [RESOURCE, 'all'] as const,
    }),
};

export { agencies, RESOURCE as AGENCIES_QUERY_KEY };
